import Ajv, { ErrorObject } from 'ajv';
import addFormats from 'ajv-formats';

const ajv = new Ajv();
addFormats(ajv);

export const validate = (schema: Parameters<Ajv['compile']>[0], data: any): ErrorObject[] => {
  const validate = ajv.compile(schema);

  if (!validate(data)) {
    return validate.errors || [];
  }
  return [];
};

export const formatValidationErrors = (errors: ErrorObject[]): Record<string, string> => {
  return errors.reduce((errorsObj, error) => {
    const property: string = 'missingProperty' in error.params ? error.params.missingProperty : error.instancePath.slice(1);
    // Todo: in case we need to differentiate errors for each property we should use ajv-errors library
    errorsObj[property] = `invalid_${property}_message`;
    return errorsObj;
  }, {});
};

export const removeFalsyElements = (obj) => {
  const newObject = {};
  Object.keys(obj).forEach((key) => {
    if (obj[key]) {
      newObject[key] = obj[key];
    }
  });
  return newObject;
};
